import { getInnerElement } from '../tools'
import store from '../../../services/tygroshka-store'

export const generalCha = (element, state) => {
  // console.log('generalf', element, state)
}
